import axios from 'axios';
import { config } from '../config/config';

const authApiService = {
    get: async (url, params = {}) => {
       
        try {
            const accessToken = localStorage.getItem("accessToken"); // Get token from localStorage
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const response = await axios.get(`${config.TENNIS_HOST}${url}`, {
                params,
                headers
            });
            return response.data;
        } catch (error) {
            console.error('GET request error:', error);
            throw error;
        }
    },

    post: async (url, data = {}) => {
        try {
            const accessToken = localStorage.getItem("accessToken"); // Get token from localStorage
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const response = await axios.post(`${config.TENNIS_HOST}${url}`, data, { headers });
            return response.data;
        } catch (error) {
            console.error('POST request error:', error);
            throw error;
        }
    },

    put: async (url, data = {}) => {
        try {
            const accessToken = localStorage.getItem("accessToken"); // Get token from localStorage
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const response = await axios.put(`${config.TENNIS_HOST}${url}`, data, { headers });
            return response.data;
        } catch (error) {
            console.error('PUT request error:', error);
            throw error;
        }
    },
    
    registerPlayer: async (url, data = {}) => {


    
        try {
            const accessToken = localStorage.getItem("accessToken"); // Get token from localStorage
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

           const response = await axios.patch(`${config.TENNIS_HOST}${url}`, data, { headers });
            return response.data;
        } catch (error) {
            console.error('PATCH request error:', error);
            throw error;
        }
    },

    delete: async (url, params = {}) => {
        try {
            const accessToken = localStorage.getItem("accessToken");
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const response = await axios.delete(`${config.TENNIS_HOST}${url}`, {
                params,
                headers
            });
            return response.data;
        } catch (error) {
            console.error('DELETE request error:', error);
            throw error;
        }
    }
};

export default authApiService;

